<div
  class="change-card"
  [ngClass]="{
    previous: cardData.changeType === EmployerContactSubmissionChangeTypeEnum.Previous,
    new: cardData.changeType === EmployerContactSubmissionChangeTypeEnum.New,
    neutral: cardData.changeType === EmployerContactSubmissionChangeTypeEnum.Neutral
  }">
  <span class="bold-label">{{ cardData.contactName }}</span>
  <app-status-pill [statusPill]="cardData.contactTypePill" />
</div>
